document.addEventListener('alpine:init', () => {  
  const AddItemsToCart = async (items_to_add) => {
    // items_to_add = [{
    //   quantity: qty,
    //   id: variant_id,
    //   selling_plan: selling_plan_id,
    //   properties: {}
    // }]
    return await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ items: items_to_add })
    })
  };

  Alpine.data('ProductForm', () => ({
    async e_AddToCartNoMonogram(e) {
      let $form = e.target.closest('form-add-to-cart');
      let quantity = $form.querySelector('.product-quantity').value;
      let variant_id = e.target.dataset.variant;
      // console.log(e, this, this.$el)
      let items_to_add = [{
        quantity,
        id: variant_id
      }]
      await AddItemsToCart(items_to_add);
      window.location.href = '/cart';
    }
  }));
})